import React, { Component } from 'react'
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { CommonValidationMessages } from '../../../utils/Messages';
import SwalServices from '../../../services/swalServices/SwalServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { PartyAccountMasterPopup } from './PartyAccountMasterTable';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import moment from 'moment';
import { permission } from '../../../utils/enums/ValidationMessage';
import { Navigate } from 'react-router-dom';
import { decryptAES } from '../../../utils/Encryption';

export default class PartyAccountMaster extends Component {
  constructor(props) {
    super(props)
    this.accountTransactionServices = new AccountTransactionServices();
    //this.accountMasterServices = new AccountMasterServices();
    this.masterEntryServices = new MasterEntryServices();
    this.SwalServices = new SwalServices();
    this.state = {
      urlId: 0,
      permissions: {
        isAddEdit: false,
        isDelete: false,
        isView: false,
      },
      isModalOpen: false,
      rowData: [],
      colDefs: [],
      paginationPageSize: 50,
      rowHeight: 40,
      idCompany: 0,
      idUser: 0,
      partyObject: {
        //selectType: 0,
        //invType: "",
        //partyType: 0,
        idPartyAccount: 0,
        updateStatus: 0,
        partyCode: "",
        partyName: "",
        partyGroup: "",
        category: "",

        contactPerson: "",
        whatsApp: "",
        contactNo1: "",
        website: "",
        contactNo2: "",
        dob: "",
        email: "",
        gstNo: "",
        panNo: "",
        address: "",
        stateCode: "",
        gstDate: "",
        place: "",
        opStock: "",
        isGSTParty: false,
        opBalance: "",
        opDate: "",
        currentBalance: 0,
        bankName: "",
        accHolder: "",
        branchName: "",
        accNo: "",
        ifsc: "",
        branchCity: "",
        invoiceDis: "",
        isDiscount: false,
        creditLimit: "",
        remarks: "",
        isJobWork: false,
        e_Date: "",

        selectedCountry: {},
        countrys: [],
        selectTDSGroups: {},
        tdsGroups: [],
        masterStateLists: [],
        masterCityLists: [],
        masterState: [],
        selectedMasterState: {},
        masterCity: [],
        selectedMasterCity: {},
        selectedType: {},
        employeeList: [],
        mainEmployeeList: [],
        selectedTypeName: "",
        selectedTypeId: 0,
        types: [
          {
            value: 1,
            label: "CUSTOMER"
          },
          {
            value: 2,
            label: "SUPPLIER"
          },
          {
            value: 3,
            label: "GENERAL"
          },
          {
            value: 4,
            label: "HO"
          },

        ],
        seletecINVType: {},
        seletecINVTypeName: "",
        seletecINVTypeId: 0,
        invTypeList: [
          {
            value: 1,
            label: 'INTRASTATE'
          },
          {
            value: 2,
            label: 'INTERSTATE'
          }
        ],
        selectedPartyType: {},
        selectedPartyTypeName: "",
        selectedPartyTypeId: 0,
        partyTypes: [
          {
            value: 1,
            label: 'MANUFACTURER'
          },
          {
            value: 2,
            label: 'TRADERS'
          },
          {
            value: 3,
            label: 'LABOUR'
          },
          {
            value: 4,
            label: 'SERVICE PROVIDER'
          }
        ],
        selectedBalanceType: {},
        selectedEmployeeName: {},
        balanceTypes: [
          {
            value: 1,
            label: 'CREDIT'
          },
          {
            value: 2,
            label: 'DEBIT'
          },
        ],
        selectPTerms: {},
        terms: [
          {
            value: 1,
            label: 'Net 15'
          },
          {
            value: 2,
            label: 'Net 30'
          },
          {
            value: 3,
            label: 'Net 45'
          },
          {
            value: 4,
            label: 'Net 60'
          },
          {
            value: 5,
            label: 'Net 90'
          },
        ],
        generalProducts: [],
        selectedGeneralProduct: {},
      },
      validState: {
        isValid: true,
        error: {},
      },
      validationRules: {
        partyName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "party name"
            ),
          },
        ],
        selectedTypeId: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "party name"
            ),
          },
        ],
        seletecINVTypeId: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "inv. type"
            ),
          },
        ],
        // selectedPartyTypeId: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "party type"
        //     ),
        //   },
        // ],
      },
    }
  }

  openPopUpForAddingItem = () => {
    if (!this.state.permissions.isAddEdit) {
      this.SwalServices.Error(permission.add);
      return;
    }
    this.setState({ isModalOpen: true }, () => {
      this.resetDetailsFields();
      // this.getMasterExpenseAccGroupCount();
    })
  };

  onRowDoubleClicked = (event) => {
    if (!this.state.permissions.isAddEdit) {
      this.SwalServices.Error(permission.edit);
      return;
    }
    this.getPartyAccountSelectbyID(event.data.idPartyAccount);
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    this.setState({
      validState: validState
    });
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.partyObject,
      this.state.validationRules,
      this.state.validState,
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  }

  setOpenModel = () => {
    if (this.state.urlId) {
      this.setState({ route: '/ledger-report' });
    }
    this.setState({ isModalOpen: !this.state.isModalOpen }, () => {
      this.resetDetailsFields();
    });
  };
  closePopup = () => {
    if (this.state.urlId) {
      this.setState({ route: '/ledger-report' });
    }
    this.setState({ isModalOpen: false, }, () => {
      this.resetDetailsFields();
    });
  };

  handleChange = (event, name) => {
    let details = this.state.partyObject;
    if (name === 'selectedType') {
      details.selectedTypeId = event.value;
      details.selectedTypeName = event.label;
    } else if (name === 'seletecINVType') {
      details.seletecINVTypeId = event.value;
      details.seletecINVTypeName = event.label;
    } else if (name === 'selectedPartyType') {
      details.selectedPartyTypeId = event.value;
      details.selectedPartyTypeName = event.label;
    } else {
      // let value = event.target.value;
      details[name] = event;
    }
    this.setState({ partyObject: details }, () => {
      //debugger
      let data = this.state.partyObject;
      if (name === "selectedCountry") {
        data.masterState = data.masterStateLists.filter(item => Number(item.name2) === data.selectedCountry?.value);
        data.selectedMasterState = {};
        data.masterCity = [];
        data.selectedMasterCity = {};
      } else if (name === "selectedMasterState") {
        data.masterCity = data.masterCityLists.filter(item => Number(item.name2) === data.selectedMasterState?.value);
        data.selectedMasterCity = {};
      } else if (name === "selectTDSGroups") {
        data.tdsPer = Number(data.selectTDSGroups.name2.replace('%', ''));
      }
      this.setState({ partyObject: details });
    });
  }

  handleChangeForFields = (event, name) => {
    let value = event.target.value;
    let details = this.state.partyObject;
    if (name === "isGSTParty" || name === "isDiscount" || name === "isJobWork") {
      details[name] = !details[name];
    } else {
      details[name] = value;
    }
    this.setState({ partyObject: details });
  }


  getPinnedWidth = (key) => {
    // const pinnedCol = {
    //     "idCashWithdraw": window.innerWidth * 0.06,
    //     "sR.No": window.innerWidth * 0.04,
    //     "employeeName": window.innerWidth * 0.18,
    // }
    // return pinnedCol[key]
  }


  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
  };

  resetDetailsFields = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let partyObject = this.state.partyObject;
    partyObject.idPartyAccount = 0;
    partyObject.updateStatus = 0;
    partyObject.partyCode = "";
    partyObject.partyName = "";
    partyObject.partyGroup = "";
    partyObject.category = "";

    partyObject.contactPerson = "";
    partyObject.whatsApp = "";
    partyObject.contactNo1 = "";
    partyObject.website = "";
    partyObject.contactNo2 = "";
    partyObject.dob = "";
    partyObject.email = "";
    partyObject.gstNo = "";
    partyObject.panNo = "";
    partyObject.address = "";
    partyObject.stateCode = "";
    partyObject.gstDate = "";
    partyObject.place = "";
    partyObject.opStock = "";
    partyObject.isGSTParty = false;
    partyObject.opBalance = "";
    partyObject.opDate = "";
    partyObject.currentBalance = 0;
    partyObject.bankName = "";
    partyObject.accHolder = "";
    partyObject.branchName = "";
    partyObject.accountNo = "";
    partyObject.ifsc = "";
    partyObject.branchCity = "";
    partyObject.invoiceDis = "";
    partyObject.isDiscount = false;
    partyObject.creditLimit = "";
    partyObject.remarks = "";
    partyObject.isJobWork = false;
    partyObject.e_Date = "";

    partyObject.selectedCountry = {};
    //countrys: [],
    partyObject.selectTDSGroups = {};
    //tdsGroups = [];
    //partyObject.masterStateLists = [];
    //partyObject.masterCityLists = [];
    partyObject.masterState = [];
    partyObject.selectedMasterState = {};
    partyObject.masterCity = [];
    partyObject.selectedMasterCity = {};
    partyObject.selectedType = {};
    partyObject.selectedTypeName = "";
    partyObject.selectedTypeId = 0;
    //partyObject.types = [ ];
    partyObject.seletecINVType = {};
    partyObject.seletecINVTypeName = "";
    partyObject.seletecINVTypeId = 0
    //partyObject.invTypeList = [];
    partyObject.selectedPartyType = {};
    partyObject.selectedPartyTypeName = "";
    partyObject.selectedPartyTypeId = 0;
    //partyObject.partyTypes = [];
    partyObject.selectPTerms = {};
    //partyObject.terms = [];
    partyObject.generalProducts = [];
    partyObject.selectedGeneralProduct = {};
    partyObject.selectedEmployeeName = {};
    this.setState({
      partyObject: partyObject, validState: validState
    }, () => {
      this.getAllDropdownForPartyMaster();
    });
  }

  componentDidMount = () => {
    let params = new URLSearchParams(window.location.search);
    let id = params.get("id");
    if (id) {
      let urlId = decryptAES(id);
      if (urlId != null) {
        this.setState({ urlId: urlId });
      }
    }

    let prop = getAuthProps()
    //debugger
    if (prop.idCompany && prop.idCompany > 0) {
      this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
        this.procSelectAllRecordsSP();
        //this.getAllDropdownForPartyMaster();
      });
    } else {
      // window.location.href = "/Login";
    } setTimeout(() => {
      //this.removeDefaultBorders();
    }, 100);
  }

  procSelectAllRecordsSP = () => {
    let request = {
      formname: "Party Account Master",
      idCompany: this.state.idCompany,
      allowToRateVisible: 1,
      idUser: 0,
      //idFinancialYear : null,
      //idPlant : 0,
    };
    this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
      if (response.statusCode == 200 && response.responseItem !== null) {
        let permissions = response.responseItem.responseContent[0][0];
        if (permissions.view) {
          let data = response.responseItem.responseContent[1];
          if (data.length > 0) {
            const dynamicColDefs = Object.keys(data[0]).map((key) => ({
              field: key.includes(".") ? key.replace(/\./g, "_") : key,
              headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
              minWidth: this.getColumnWidth(key),
              flex: 1,
              filter: true,
              floatingFilter: true,
              hide: ["idPartyAccount"].includes(key) ? true : false,
              // width: this.getPinnedWidth(key),
              valueGetter: (params) => params.data[key],
              // valueFormatter: key.includes("date") || key.includes("invoiceDate")
              //   ? (params) => {
              //     if (!params.value) return "";
              //     return moment(params.value).format("DD-MM-YYYY");
              //   }
              //   : undefined,
              //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
            }));
            //const priorityColumn = "bankName"; // Replace with the actual column name
            //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
            //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
            //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

            // const updatedColDefs = [
            //   ...pinnedColumns,
            //   ...(priorityColDef ? [priorityColDef] : []),
            //   ...otherColumns,
            // ];
            var colName = dynamicColDefs[0].field;
            let id = data ? data[0][colName] : 0;
            this.setState({
              rowData: data,
              colDefs: dynamicColDefs, //updatedColDefs,
              caption: "Party Account Master",
              colName: colName
            }, () => {
              this.getAllDropdownForPartyMaster();
              this.setPermissions(permissions);

              if (this.state.urlId) {
                this.openPopUpFromURLId(this.state.urlId);
              }
            });
          } else {
            this.setPermissions(permissions);
            if (this.gridApi) {
            }
          }
        } else {
          window.location.href = "/authentication/UnAuthorized";
        }
      }
    });
  }

  setPermissions = (permissions) => {
    let data = this.state.permissions;
    data.isAddEdit = permissions.addEdit;
    data.isDelete = permissions.delete;
    data.isView = permissions.view;
    this.setState({ permissions: data });
  }

  getColumnWidth = (key) => {
    const colwidth = {
      "sR.No": window.innerWidth * 0.05,
      "type": window.innerWidth * 0.09,
      "partyACName": window.innerWidth * 0.25,
      "p_Address": window.innerWidth * 0.15,
      "contactNo": window.innerWidth * 0.09,
      "emailID": window.innerWidth * 0.1,
      "gstNo": window.innerWidth * 0.13,
    }
    return colwidth[key]
  }

  getAllDropdownForPartyMaster = () => {
    this.masterEntryServices.getAllDropdownForPartyMaster(this.state.idCompany).then((response) => {
      //debugger
      if (response.statusCode == 200 && response.responseItem !== null) {
        let allData = response.responseItem.responseContent;
        let data = this.state.partyObject;
        data.countrys = allData.filter(item => item.source === 'Country'); //designations.map((p) => ({ value: p.id, label: p.name }));
        data.tdsGroups = allData.filter(item => item.source === 'TDSGroup');
        data.generalProducts = allData.filter(item => item.source === 'GeneralProduct');
        data.masterStateLists = allData.filter(item => item.source === 'Master_State');
        data.masterCityLists = allData.filter(item => item.source === 'Master_City');

        let partyCode = allData.filter(item => item.source === 'PartyAccountCount');
        data.partyCode = partyCode?.[0].value > 0 ? (partyCode?.[0].value + 1) : (0 + 1);

        this.setState({
          partyObject: data
        }, () => {
          this.usp_Master_EmployeeSelect()
        });
      } else {
        this.usp_Master_EmployeeSelect()
      }
    });
  }

  usp_Master_EmployeeSelect = () => {
    this.accountTransactionServices.usp_Master_EmployeeSelect_WithNewChanges(this.state.idCompany).then((response) => {
      // debugger
      if (response.statusCode == 200 && response.responseItem !== null) {
        let data = response.responseItem.responseContent;
        data = data.map((x) => ({
          value: x.idEmployee,
          label: x.employeeName,
          idGeneralProduct: x.idGeneralProduct
        }));
        let receiptDetail = this.state.partyObject;
        receiptDetail.employeeList = data;
        receiptDetail.mainEmployeeList = data;
        this.setState({
          partyObject: receiptDetail
        });
      } else {
        // this.usp_Master_BankSelect();
      }
    });
  }


  submit = () => {
    const isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      let details = this.state.partyObject;
      let requestData = {
        idPartyAccount: details.idPartyAccount,
        partyACCode: details.partyCode,
        type: details.selectedTypeId ? details.types.find(x => x.value === details.selectedTypeId).label : '',
        partyACType: details.selectedPartyTypeId ? details.partyTypes.find(x => x.value === details.selectedPartyTypeId).label : '',
        partyACName: details.partyName,
        p_Address: details.address,
        group: details.partyGroup,
        category: details.category,
        contactPerson: details.contactPerson,
        contactNo: details.contactNo1,
        whatsappNo: details.whatsApp,
        contactNo2: details.contactNo2,
        website: details.website,
        emailID: details.email,
        dob: (details.dob && details.dob !== 'Invalid date') ? details.dob : null,
        panNo: details.panNo,
        gstNo: details.gstNo,
        gstDate: (details.gstDate && details.gstDate !== 'Invalid date') ? details.gstDate : null,
        openingBalance: details.opBalance,
        opBalanceDate: (details.opDate && details.opDate !== 'Invalid date') ? details.opDate : null,
        currentBalance: details.currentBalance,
        balanceType: details.selectedBalanceType.label,
        bankName: details.bankName,
        acHolder: details.accHolder,
        branchName: details.branchName,
        accountNo: details.accountNo,
        ifscNo: details.ifsc,
        branchCity: details.branchCity,
        customerDiscount: details.invoiceDis,
        applyDiscount: details.isDiscount,
        paymentTerms: details.selectPTerms.label,
        creditLimit: details.creditLimit,
        remarks: details.remarks,
        isJobWork: details.isJobWork,
        idCompany: this.state.idCompany,
        e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
        isUpdated: details.updateStatus,
        updatedDate: details.updateStatus > 0 ? new Date().toISOString() : null,
        isDeleted: false,
        deletedDate: null,
        placeofSupply: details.place,
        stateCode: details.stateCode,
        idCountry: details?.selectedCountry?.value,
        idState: details?.selectedMasterState?.value,
        idCity: details?.selectedMasterCity?.value,
        tds: details.tdsPer,
        idTdsGroup: details?.selectTDSGroups?.value,
        invoiceType: details.seletecINVTypeId ? details.invTypeList.find(x => x.value === details.seletecINVTypeId).label : '',
        idGeneralProduct: details?.selectedGeneralProduct?.value,
        gstParty: details.isGSTParty,
        opStock: details.opStock,
        employeeId: details.selectedEmployeeName?.value
      };
      //debugger
      this.masterEntryServices.submitPartyAccountInsertUpdate(requestData)
        .then((response) => {
          if (response.statusCode == 200 && response.responseItem !== null) {
            let dynamicData = response.responseItem.responseContent;
            if (dynamicData !== null) {
              if (response.responseItem?.responseContent?.errorColumne === 'Type') {
                this.SwalServices.Error("Type are already exists");
              } else if (response.responseItem?.responseContent?.errorColumne === 'PartyACName') {
                this.SwalServices.Error("Party AC Name are already exists");
              } else if (response.responseItem?.responseContent?.errorType === 'Exists') {
                this.SwalServices.Error(response.responseItem?.responseContent?.errorMessage);
              } else {
                if (this.state.partyObject.updateStatus === 1) {
                  this.SwalServices.Success("Updated successfully.");
                } else {
                  this.SwalServices.Success("Saved successfully.");
                }
                if (this.state.urlId) {
                  this.setState({ route: '/ledger-report' });
                } else {
                  this.resetDetailsFields();
                  // Call resetFields here after submission
                  this.setState(
                    { isModalOpen: false },
                    () => {
                      this.procSelectAllRecordsSP(); // Fetch latest records
                    }
                  );
                }
              }

            } else {
              this.procSelectAllRecordsSP();
            }
          } else {
            this.setState(
              { isModalOpen: false },
              () => {
                this.SwalServices.Error(response.message);
                this.procSelectAllRecordsSP(); // Fetch latest records
              }
            );
          }
        });
    }
  };

  openPopUpFromURLId = (id) => {
    let details = this.state.partyObject;
    details.idPartyAccount = id;
    this.setState({ partyObject: details }, () => {
      this.getPartyAccountSelectbyID(this.state.partyObject.idPartyAccount);
    });
  };

  getPartyAccountSelectbyID = (id) => {
    this.masterEntryServices.getPartyAccountSelectbyID(id)
      .then((response) => {
        if (response.statusCode == 200 && response.responseItem !== null) {
          let dynamicData = response.responseItem.responseContent[0];
          if (dynamicData !== null) {
            let partyObject = this.state.partyObject;
            //debugger;
            partyObject.idPartyAccount = dynamicData.idPartyAccount;
            partyObject.updateStatus = 1;
            partyObject.partyCode = dynamicData.partyACCode;
            partyObject.partyName = dynamicData.partyACName;
            partyObject.partyGroup = dynamicData.group;
            partyObject.category = dynamicData.category;

            partyObject.contactPerson = dynamicData.contactPerson;
            partyObject.whatsApp = dynamicData.whatsappNo;
            partyObject.contactNo1 = dynamicData.contactNo;
            partyObject.website = dynamicData.website;
            partyObject.contactNo2 = dynamicData.contactNo2;
            partyObject.dob = moment(dynamicData.dob).format('YYYY-MM-DD');
            partyObject.email = dynamicData.emailID;
            partyObject.gstNo = dynamicData.gstNo;
            partyObject.panNo = dynamicData.panNo;
            partyObject.address = dynamicData.p_Address;
            partyObject.stateCode = dynamicData.stateCode;
            partyObject.gstDate = moment(dynamicData.gstDate).format('YYYY-MM-DD');
            partyObject.place = dynamicData.placeofSupply;
            partyObject.opStock = dynamicData.opStock;
            partyObject.isGSTParty = dynamicData.gstParty;
            partyObject.opBalance = dynamicData.openingBalance;
            partyObject.opDate = moment(dynamicData.opBalanceDate).format('YYYY-MM-DD');
            partyObject.currentBalance = dynamicData.currentBalance;
            partyObject.bankName = dynamicData.bankName;
            partyObject.accHolder = dynamicData.acHolder;
            partyObject.branchName = dynamicData.branchName;
            partyObject.accNo = dynamicData.accountNo;
            partyObject.ifsc = dynamicData.ifscNo;
            partyObject.branchCity = dynamicData.branchCity;
            partyObject.invoiceDis = dynamicData.customerDiscount;
            partyObject.isDiscount = dynamicData.applyDiscount;
            partyObject.creditLimit = dynamicData.creditLimit;
            partyObject.remarks = dynamicData.remarks;
            partyObject.isJobWork = dynamicData.isJobWork;
            partyObject.e_Date = dynamicData.e_Date;
            partyObject.tdsPer = dynamicData.tds;
            partyObject.accountNo = dynamicData.accountNo;
            partyObject.creditLimit = dynamicData.creditLimit;
            //partyObject.branchName = dynamicData.creditLimit;

            partyObject.selectedCountry = dynamicData.idCountry > 0 ? partyObject.countrys?.find(item => item.value === dynamicData.idCountry) : {};
            //countrys: [],
            partyObject.selectTDSGroups = dynamicData.idtdsGroup > 0 ? partyObject.tdsGroups?.find(item => item.value === dynamicData.idtdsGroup) : {};
            //tdsGroups = [];
            //partyObject.masterStateLists = [];
            //partyObject.masterCityLists = [];
            partyObject.masterState = partyObject.masterStateLists?.filter(item => Number(item.name2) === dynamicData.idCountry);
            partyObject.selectedMasterState = dynamicData.idState > 0 ? partyObject.masterState?.find(item => item.value === dynamicData.idState) : {};
            partyObject.masterCity = partyObject.masterCityLists.filter(item => Number(item.name2) === dynamicData.idState);
            partyObject.selectedMasterCity = dynamicData.idCity > 0 ? partyObject.masterCity?.find(item => item.value === dynamicData.idCity) : {};
            partyObject.selectedType = dynamicData.type ? partyObject.types?.find(item => item.label === dynamicData.type) : {};
            partyObject.selectedTypeName = dynamicData.type;
            partyObject.selectedTypeId = dynamicData.type ? partyObject.types?.find(item => item.label === dynamicData.type)?.value : "";
            //partyObject.types = [ ];
            partyObject.seletecINVType = dynamicData.invoiceType ? partyObject.invTypeList?.find(item => item.label === dynamicData.invoiceType) : {};
            partyObject.seletecINVTypeName = dynamicData.invoiceType;
            partyObject.seletecINVTypeId = dynamicData.invoiceType ? partyObject.invTypeList?.find(item => item.label === dynamicData.invoiceType)?.value : "";
            //partyObject.invTypeList = [];
            partyObject.selectedPartyType = dynamicData.partyACType ? partyObject.partyTypes?.find(item => item.label === dynamicData.partyACType) : {};
            partyObject.selectedPartyTypeName = dynamicData.partyACType;
            partyObject.selectedPartyTypeId = dynamicData.partyACType ? partyObject.partyTypes?.find(item => item.label === dynamicData.partyACType)?.value : "";
            //partyObject.partyTypes = [];
            partyObject.selectPTerms = dynamicData.paymentTerms ? partyObject.terms?.find(item => item.label.toLocaleLowerCase() === dynamicData.paymentTerms.toLocaleLowerCase()) : {};
            //partyObject.terms = [];
            //partyObject.generalProducts = [];
            partyObject.selectedGeneralProduct = dynamicData.idGeneralProduct > 0 ? partyObject.generalProducts?.find(item => item.value === dynamicData.idGeneralProduct) : {};
            partyObject.selectedBalanceType = dynamicData.balanceType ? partyObject.balanceTypes?.find(item => item.label === dynamicData.balanceType) : {};
            partyObject.selectedEmployeeName = dynamicData.employeeId ? partyObject.employeeList?.find(item => item.value === dynamicData.employeeId) : {};
            this.setState({ partyObject: partyObject, isModalOpen: true });
          }
        }
      });
  }

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className='party-master'>
        <div className='data-display'>
          <div className='data-display-inner relative'>
            <ButtonGrp buttons={['add', 'print', 'delete']}
              onClickHandlers={{
                add: () => this.openPopUpForAddingItem(),
                // update: () => this.openPopUpForUpdateItem(),
                print: this.handlePrint,
                delete: this.handleDelete,
              }}
            />
            <PartyAccountMasterPopup
              isModalOpen={this.state.isModalOpen}
              setOpenModel={this.setOpenModel.bind(this)}
              partyObject={this.state.partyObject}
              handleChange={this.handleChange.bind(this)}
              handleChangeForFields={this.handleChangeForFields.bind(this)}
              // setFilterParameters={this.setFilterParameters.bind(this)}
              close={this.closePopup.bind(this)}
              submit={this.submit.bind(this)}
              //next={this.next.bind(this)}
              validState={this.state.validState}
            />
            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
              <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                <div className="table-inner">
                  <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Party account master</h1>
                </div>
                <AgGridReact
                  rowData={this.state.rowData}
                  rowHeight={this.state.rowHeight}
                  columnDefs={this.state.colDefs}
                  pagination={true}
                  paginationPageSize={this.state.paginationPageSize}
                  onRowDoubleClicked={this.onRowDoubleClicked}
                  onGridReady={this.onGridReady}
                  overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                  overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
